import getCdnUrl from '@fingo/lib/helpers/get-cdn-url';

const WomanImage = getCdnUrl('/landings/simulator-register-woman.avif');

export default WomanImage;
